import { render } from "./ProdutosCatalogoCards.vue?vue&type=template&id=7976ab8d&scoped=true"
import script from "./ProdutosCatalogoCards.vue?vue&type=script&lang=js"
export * from "./ProdutosCatalogoCards.vue?vue&type=script&lang=js"

import "./ProdutosCatalogoCards.vue?vue&type=style&index=0&id=7976ab8d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7976ab8d"]])

export default __exports__